//-------------------------- verification  -------------------------- //

window.stepCheck = {}

stepCheck.stepDetails = async function (stepSelected, with_error, with_target, is_step_handle) {
    const stepElement = steps[stepSelected]
    let error = false

    // First Name
    const first_name = stepElement.querySelector('#first_name')

    if (first_name.value.length < 2 || isAlphaString(first_name.value) === false) {
        error = true

        if (with_target == null || with_target === 'first_name') {
            toggleInputError(first_name, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'first_name') {
            toggleInputError(first_name, stepElement, true, with_error)
        }
    }

    // Last Name
    const last_name = stepElement.querySelector('#last_name')

    if (last_name.value.length === 0 || isAlphaString(last_name.value) === false) {
        error = true

        if (with_target == null || with_target === 'last_name') {
            toggleInputError(last_name, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'last_name') {
            toggleInputError(last_name, stepElement, true, with_error)
        }
    }

    // Address
    const address = stepElement.querySelector('#address')

    if (address.value.length === 0) {
        error = true

        if (with_target == null || with_target === 'address') {
            toggleInputError(address, stepElement, false, with_error)
        }
    } else {
        if (hasAddressDetails() === false) {
            error = true

            if (with_target == null || with_target === 'address') {
                toggleInputError(address, stepElement, false, with_error)
            }
        } else {
            if (with_target == null || with_target === 'address') {
                toggleInputError(address, stepElement, true, with_error)
            }
        }
    }

    // Phone
    const phone = stepElement.querySelector('#phone')

    if (isPhone(phone.value) === false) {
        error = true

        if (with_target == null || with_target === 'phone') {
            toggleInputError(phone, stepElement, false, with_error)
        }
    } else {
        if (is_step_handle === true) { // Do phone verification only when button is clicked
            toggleLoading(phone, true)

            let is_valid = await twilioVerify(phone.value)

            toggleLoading(phone, false)

            if (is_valid === true) {
                toggleInputError(phone, stepElement, true, with_error)
            } else {
                error = true

                toggleInputError(phone, stepElement, false, with_error)
            }
        } else {
            if (with_target == null || with_target === 'phone') {
                toggleInputError(phone, stepElement, true, with_error)
            }
        }
    }

    // Email
    const email = stepElement.querySelector('#email')

    if (isEmailAddress(email.value) === false) {
        error = true

        if (with_target == null || with_target === 'email') {
            toggleInputError(email, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'email') {
            toggleInputError(email, stepElement, true, with_error)
        }
    }

    // Agent
    const agent = stepElement.querySelector('#agent')

    if (agent.value.length === 0 || isAlphaString(agent.value) === false) {
        error = true

        if (with_target == null || with_target === 'agent') {
            toggleInputError(agent, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'agent') {
            toggleInputError(agent, stepElement, true, with_error)
        }
    }

    // TCPA info
    const tcpa_info = stepElement.querySelector('#tcpa_info')

    if (tcpa_info.checked) {
        if (with_target == null || with_target === 'tcpa_info') {
            stepElement.querySelector('.tcpa-info').classList.remove('text-danger')
        }
    } else {
        error = true

        if (with_target == null || with_target === 'tcpa_info') {
            stepElement.querySelector('.tcpa-info').classList.add('text-danger')
        }
    }

    toggleFormError(error)

    return error
}

//-------------------------- binds  -------------------------- //

window.setupBind = {}

setupBind.stepDetails = function (stepElement, stepKey) {
    //first_name
    let inputFirstName = stepElement.querySelector('#first_name')

    inputFirstName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'first_name')
    })

    inputFirstName.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'first_name')
    })

    //last_name
    let inputLastName = stepElement.querySelector('#last_name')

    inputLastName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'last_name')
    })

    inputLastName.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'last_name')
    })

    //address
    let inputAddress = stepElement.querySelector('#address')

    inputAddress.addEventListener('keydown', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        resetAddressComponent()

        stepCheck.stepDetails(stepKey, false, 'address')
    })

    inputAddress.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'address')
    })

    //email
    let inputEmail = stepElement.querySelector('#email')

    inputEmail.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'email')
    })

    inputEmail.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'email')
    })

    //phone
    let inputPhone = stepElement.querySelector('#phone')

    inputPhone.addEventListener('keydown', async (event) => {
        if (!upKeyCodePhone(event)) {
            event.preventDefault()
        }
    })

    inputPhone.addEventListener('keyup', async (event) => {
        if (formatKeyCodePhone(event)) {
            formatToPhone(event)

            await stepCheck.stepDetails(stepKey, false, 'phone')
        }
    })

    inputPhone.addEventListener('change', async (event) => {
        formatToPhone(event)

        await stepCheck.stepDetails(stepKey, false, 'phone')
    })

    //agent
    let inputAgent = stepElement.querySelector('#agent')

    inputAgent.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'agent')
    })

    inputAgent.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'agent')
    })

    //tcpa_info
    let inputTcpaInfo = stepElement.querySelector('#tcpa_info')

    inputTcpaInfo.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'tcpa_info')
    });
}

//-------------------------- form  -------------------------- //

submitHandle = function (button) {
    const form = button.form
    const formData = new FormData(form)

    stepNextButtonLoading(button, false) //this actually disable overlay

    if (typeof options.submitCallback !== 'undefined' && typeof options.submitCallback === 'function') {
        options.submitCallback(formData)
    }

    //process
    fetch(options.processURL, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '*',
        }
    })
}
